export default "__VITE_ASSET__CoF4wACa__"